import { render } from "./Web.vue?vue&type=template&id=4f35e546"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"

import "./assets/tailwind.css?vue&type=style&index=0&lang=css&external"
import "./Web.vue?vue&type=style&index=1&id=4f35e546&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__